import './context-fields-area.scss'

import { FormApi } from 'final-form'
import Vue from "vue"
import Component from "vue-class-component"

import { Signer, ReportFeatured } from '@skinsoft/types'
import { DatePicker, EnhancedTextArea, EnhancedTextInput } from '@skinsoft/ui'

import { Signers } from '../../signers';

@Component({
    components: {
        sDatePicker: DatePicker,
        sEnhancedTextArea: EnhancedTextArea,
        sEnhancedTextInput: EnhancedTextInput,
        sSigners: Signers,
    },
    props: ["reportFeatured", "form", "fieldName", "signers"],
    template: require("./context-fields-area.html")
})
export class ContextFieldsArea extends Vue {

    public reportFeatured: ReportFeatured;
    public fieldName: string;
    public signers: Signer[];

    public form: FormApi;

    // getters returning fields name according to data path in condition report object
    public get dateFieldName() {
        return `${this.fieldName}.conditionReportCS.reportDate`
    }

    public get locationFieldName() {
        return `${this.fieldName}.conditionReportCS.location.translatedString.${this.$i18n.locale}`
    }
}